import { DataManager } from "../model/DataManager.js";
import { VOAttachment, VOBlog } from "../model/DataStructure.js";
import { DateUtil } from "../model/DateUtil.js";
import { LanguageCode, Translation } from "../model/Language.js";
import { BaseElement, BaseElementOptions } from "./BaseElement.js";
import { Menu, MenuButton } from "./Menu.js";
import { Unsupported } from "./Unsupported.js";

export interface BlogPrintOptions extends BaseElementOptions {
    element: HTMLDivElement;
    assetsUrl: string;
    pdfUrl: string;
}

export class BlogPrint extends BaseElement {

    private _menu: Menu;
    private _data: DataManager;
    private _content: HTMLDivElement;
    private _items: BlogPrintItem[] = [];
    private _activeToggle: MenuButton;
    private _from: JQuery<HTMLElement>;
    private _to: JQuery<HTMLElement>;
    private _reset: MenuButton;
    private _printButton: MenuButton;
    private _downlaodButton: MenuButton;
    private _container: HTMLDivElement;
    private _assetsUrl: string;
    private _pdfUrl: string;

    public create(options: BlogPrintOptions): this {

        options = e5.object.merge({
            element: null
        } as BlogPrintOptions, options);

        this._assetsUrl = options.assetsUrl;
        this._pdfUrl = options.pdfUrl;

        super.create(options);
        this.setElement(options.element);

        var isSupported = !(e5.Caps.isInternetExplorer
            || e5.Caps.isIOS
            || e5.Caps.isMobile);
        isSupported = true;
        if (!isSupported) {
            new Unsupported().create({
                container: this.element,
                message: {
                    de: "Die Druckfunktion kann auf ihrem Browser nicht ausgeführt werden.<br>Bitte verwenden Sie einen aktuellen Browser:",
                    en: "The print function cannot be carried out on your browser.<br>Please use an up-to-date browser:"
                },
                icon: "fal fa-print-slash"
            });
        } else {
            this.init();
        }

        return this;
    }

    private async init() {

        this._data = new DataManager();
        await this._data.load(this.element.getAttribute("data-dataurl"));

        this._container = document.createElement("div");
        this._container.className = "awi-blog-print__container";
        this.element.appendChild(this._container);

        await this.initMenu();

        this._content = document.createElement("div");
        this._content.className = "awi-blog-print__content";
        this._container.appendChild(this._content);

        var page = new e5.PrintLayout();
        page.footer.classList.add("awi-blog-print__blog-footer");
        page.footer.innerHTML = `<img src="${this._assetsUrl}awi-logo.png"/>`;
        // page.header.innerHTML = "HEADER";
        // page.footer.innerHTML = "FOOTER";
        page.sync();
        this._content.appendChild(page.element);

        for (var blog of this._data.data.awi_blog) {
            var item = new BlogPrintItem({
                blog: blog
            });
            this._items.push(item);
            item.onChange.add(this.handleChangeItem, this);
            item.onReady.add(this.handleReadyItem, this);
            this._content.appendChild(item.element);
            page.content.appendChild(item.printContent);
        }

        this.handleReadyItem();
        this.handleChangeSelection();
        lang.onChange.add(() => this.handleChangeSelection());

        e5.event.on({
            scope: this.element,
            type: "click",
            selector: "[data-expedition]",
            listener: (e) => {
                var expeditionId = parseInt(e.target.getAttribute("data-expedition"));
                var exp = this._data.data.awi_expedition.id(expeditionId);
                if (exp) {
                    this.setDate(exp.date_begin, exp.date_end);
                }
            }
        });


        e5.event.on({
            scope: this.element,
            type: "click",
            selector: "[data-blog]",
            listener: (e) => {
                var blogId = parseInt(e.target.getAttribute("data-blog"));
                var blog = this._data.data.awi_blog.id(blogId);
                if (blog) {
                    this.setDate(blog.date, blog.date);
                }
            }
        });

        return true;
    }

    private handleChangeSelection(): void {

        var ids: number[] = [];
        for (var item of this._items) {
            if (item.active && !item.disabled) {
                ids.push(item.blog.id);
            }
        }

        this._downlaodButton.disabled = ids.length === 0;
        if (this._downlaodButton.disabled) {
            (this._downlaodButton.element as HTMLAnchorElement).href = "#";
            (this._downlaodButton.element as HTMLAnchorElement).target = "_self";
        } else {
            (this._downlaodButton.element as HTMLAnchorElement).href = e5.Url.params.setEntries({
                blogs: ids.join(","),
                lang: lang.current
            }, this._pdfUrl);
            (this._downlaodButton.element as HTMLAnchorElement).target = "_print";
        }
    }

    private async initMenu() {
        this._menu = new Menu().create({
            container: this._container
        });

        this._printButton = this._menu.addButton({
            icon: "fal fa-print",
            disabled: true,
            ariaLabel: {
                de: "Auswahl Drucken",
                en: "Print selection"
            },
            ariaLabelDisabled: {
                de: "Bitte warten",
                en: "Please wait"
            },
            showTooltip: true
        });
        this._printButton.element.addEventListener("click", () => {
            if (!this._printButton.disabled) {
                this.print();
            }
        });

        //TODO: remove all the Browser Print stuff ???
        this._printButton.element.remove();

        this._downlaodButton = this._menu.addButton({
            icon: "fal fa-arrow-to-bottom",
            ariaLabel: {
                de: "Auswahl als PDF speichern",
                en: "Save selection as PDF"
            },
            ariaLabelDisabled: {
                de: "Bitte wählen Sie mindestens einen Blog",
                en: "Please select at least a one blog"
            },
            tagName: "a",
            showTooltip: true
        });
        // this._downlaodButton.element.setAttribute("download", "Blogs");

        this._reset = this._menu.addButton({
            icon: "fal fa-backspace",
            position: "end",
            visible: false,
            ariaLabel: {
                de: "Datum zurücksetzen",
                en: "Reset date"
            },
            showTooltip: true
        });
        this._reset.element.addEventListener("click", () => {
            this.setDate(this._data.data.date_begin, this._data.data.date_end);
        });

        var from = this.addDatepicker({
            de: "Von",
            en: "From"
        },
            this._data.data.date_begin);
        from.on("change", () => {
            to.datepicker("option", "minDate", this.convertForDatepicker(this.getDate(this._from)));
        });
        from.datepicker("option", "maxDate", this.convertForDatepicker(this._data.data.date_end));
        from.datepicker("option", "minDate", this.convertForDatepicker(this._data.data.date_begin));
        this._from = from;

        var to = this.addDatepicker({
            de: "Bis",
            en: "To"
        },
            this._data.data.date_end);
        to.on("change", () => {
            from.datepicker("option", "maxDate", this.convertForDatepicker(this.getDate(this._to)));
        });
        to.datepicker("option", "maxDate", this.convertForDatepicker(this._data.data.date_end));
        to.datepicker("option", "minDate", this.convertForDatepicker(this._data.data.date_begin));
        this._to = to;

        this._activeToggle = this._menu.addButton({
            icon: "fal fa-circle",
            iconActive: "fal fa-check-circle",
            position: "end",
            active: true,
            ariaLabel: {
                de: "Alle auswählen",
                en: "Select all"
            },
            ariaLabelActive: {
                de: "Alle abwählen",
                en: "Deselect all"
            },
            showTooltip: true
        });

        this._activeToggle.element.addEventListener("click", () => {
            this._activeToggle.active = !this._activeToggle.active;
            for (var item of this._items) {
                item.active = this._activeToggle.active;
            }
            this.handleChangeSelection();
        });

        return true;
    }

    private setDate(begin: Date, end: Date): void {
        if (begin) {
            begin = DateUtil.clamp(begin, this._data.data.date_begin, this._data.data.date_end);
        }
        if (end) {
            end = DateUtil.clamp(end, this._data.data.date_begin, this._data.data.date_end);
        }

        // if (begin) {
        //     begin = DateUtil.roundForceUtc(begin);
        // }

        // if (end) {
        //     end = DateUtil.roundForceUtc(end);
        // }

        this._from.datepicker("option", "maxDate", this.convertForDatepicker(end));
        this._from.datepicker("setDate", this.convertForDatepicker(begin));

        this._to.datepicker("option", "minDate", this.convertForDatepicker(begin));
        this._to.datepicker("setDate", this.convertForDatepicker(end));


        var resetable = false;
        if (begin && end) {
            resetable = !(DateUtil.equal(this._data.data.date_begin, begin)
                && DateUtil.equal(this._data.data.date_end, end));
        } else {
            resetable = true;
        }
        this._reset.visible = resetable;

        for (var item of this._items) {

            var visible = true;
            if (visible && begin) {
                if (DateUtil.smaller(item.blog.date, begin)) {
                    visible = false;
                }
            }
            if (visible && end) {
                if (DateUtil.greater(item.blog.date, end)) {
                    visible = false;
                }
            }
            item.disabled = !visible;
        }

        this.handleChangeSelection();
    }

    private handleReadyItem(item: BlogPrintItem = null): void {

        var readyCount = 0;
        for (var it of this._items) {
            if (it.isReady) {
                readyCount++;
            }
        }

        this._printButton.disabled = readyCount < this._items.length;

        this.handleChangeSelection();
    }

    private handleChangeItem(item: BlogPrintItem): void {

        var activeCount = 0;
        for (var it of this._items) {
            if (it.active) {
                activeCount++;
            }
        }

        if (activeCount === 0) {
            this._activeToggle.active = false;
        } else if (activeCount === this._items.length) {
            this._activeToggle.active = true;
        }

        this.handleChangeSelection();
    }

    private async print() {
        return e5.Print.print({
            element: this._content
        });
    }

    private handleChangeDatepicker(): void {
        this.setDate(
            this.getDate(this._from),
            this.getDate(this._to)
        )
    }

    private getDate(dp: JQuery): Date {
        var d = dp.datepicker("getDate");
        if (d) {
            d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
            return d;
        }
        return null;
    }

    private setDatepickerDate(dp: JQuery, date: Date): JQuery {
        dp.datepicker("setDate", this.convertForDatepicker(date));
        return dp;
    }

    private convertForDatepicker(date: Date): Date {
        if (date) {
            date = new Date(date);
            date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
            return date;
        }
        return null;
    }

    private addDatepicker(label: Translation, date: Date) {
        var btn = this._menu.addButton({
            label: label,
            tagName: "div",
            position: "end"
        });

        var inp = document.createElement("input");
        btn.element.appendChild(inp);
        var dp = jQuery(inp).datepicker({
            dateFormat: "dd.mm.yy",
            changeYear: true,
            changeMonth: true,
            onSelect: () => this.handleChangeDatepicker()
        }).on("change", () => this.handleChangeDatepicker());
        this.setDatepickerDate(dp, date);
        return dp;
    }
}

export interface BlogPrintItemOptions {
    blog: VOBlog;
}

export class BlogPrintItem {

    public onChange = e5.Signal.create<[BlogPrintItem]>();
    public onReady = e5.Signal.create<[BlogPrintItem]>();

    public element: HTMLDivElement;
    public printContent: HTMLDivElement;
    public blog: VOBlog;

    private _menu: Menu;
    private _active: MenuButton;
    private _spinner: MenuButton;
    private _filesTotal = 0;
    private _filesLoaded = 0;

    constructor(options: BlogPrintItemOptions) {
        var blog = options.blog;
        this.blog = blog;

        this._menu = new Menu().create({
            container: this.element
        });
        this.element = this._menu.element;
        this.element.classList.add("awi-blog-print__blog-header");

        var tit = this._menu.addButton({
            label: {
                de: blog.title_de,
                en: blog.title_en
            },
            tagName: "div"
        });
        tit.element.style.minWidth = "220px";
        tit.element.style.justifyContent = "start";

        if (blog.expedition) {
            var exp = this._menu.addButton({
                label: {
                    de: blog.expedition.title_short_de,
                    en: blog.expedition.title_short_en
                }
            });
            exp.element.setAttribute("data-expedition", blog.expedition.id + "");
        }

        var d = this._menu.addButton({
            label: DateUtil.toStringReadableNumeric(blog.date),
            tagName: "div"
        });
        d.element.setAttribute("data-blog", blog.id + "");


        this._spinner = this._menu.addButton({
            icon: "fal fa-spinner fa-spin",
            position: "end"
        });

        var active = this._menu.addButton({
            icon: "fal fa-circle",
            iconActive: "fal fa-check-circle",
            position: "end"
        });
        active.active = true;
        active.element.addEventListener("click", () => {
            this.active = !this.active;
            this.onChange.dispatch(this);
        });
        this._active = active;

        var body = document.createElement("div");
        body.className = "awi-blog-print__blog-body";
        this.printContent = body;

        if (blog.media_de || blog.media_en) {

            if (blog.media_de === blog.media_en) {
                this.createImage(blog.media_de);
            } else {
                if (blog.media_de) {
                    this.createImage(blog.media_de, "de");
                }
                if (blog.media_en) {
                    this.createImage(blog.media_en, "en");
                }
            }
        } else {
            this._spinner.remove();
        }

        var title = document.createElement("h2");
        title.className = "awi-blog-print__blog-title";
        body.appendChild(title);
        lang.set(title, {
            de: blog.title_de,
            en: blog.title_en
        });

        var subtitle = document.createElement("span");
        subtitle.className = "awi-blog-print__blog-subtitle";
        body.appendChild(subtitle);
        if (blog.subtitle_de || blog.subtitle_en) {
            lang.set(subtitle, {
                de: (blog.subtitle_de || blog.subtitle_en) + " // " + DateUtil.toStringReadable(blog.date, "de"),
                en: (blog.subtitle_en || blog.subtitle_de) + " // " + DateUtil.toStringReadable(blog.date, "en")
            });
        } else {
            lang.set(subtitle, {
                de: DateUtil.toStringReadable(blog.date, "de"),
                en: DateUtil.toStringReadable(blog.date, "en")
            });
        }

        if (blog.text_de || blog.text_en) {
            var text = document.createElement("div");
            text.classList.add("awi-blog-print__blog-text", "awi-rich-text");
            body.appendChild(text);
            lang.set(text, {
                type: "html",
                de: blog.text_de,
                en: blog.text_en
            });
        }
    }

    public get isReady(): boolean {
        return this._filesLoaded === this._filesTotal;
    }

    private increaseFilesLoaded(): void {
        this._filesLoaded++;
        if (this._filesLoaded === this._filesTotal) {
            this._spinner.remove();
            this.onReady.dispatch(this);
        }
    }

    private createImage(media: VOAttachment, language: LanguageCode = null): HTMLElement {

        var div = document.createElement("div");
        div.className = "awi-blog-print__blog-image-container";
        this.printContent.appendChild(div);

        if (language) {
            div.classList.add("awi-base__only-" + language);
        }

        var img = document.createElement("img");
        this._filesTotal++;

        img.onerror = () => this.increaseFilesLoaded();
        img.onload = () => this.increaseFilesLoaded();

        img.width = media.sizes["large-width"];
        img.height = media.sizes["large-height"];
        img.src = media.sizes.large;
        div.appendChild(img);

        if (media.info.author_de || media.info.author_en) {
            var caption = document.createElement("div");
            caption.className = "awi-blog-print__blog-image-caption";
            lang.set(caption,
                {
                    type: "html",
                    de: media.info.author_de,
                    en: media.info.author_en
                });
            div.appendChild(caption);
        }

        return img;
    }

    public get active(): boolean {
        return this._active.active;
    }

    public set active(value: boolean) {
        this._active.active = value;
        this.printContent.classList.toggle("e5-hidden", this.disabled || !value);
    }

    public get disabled(): boolean {
        return this._menu.disabled;
    }

    public set disabled(value: boolean) {
        this._menu.disabled = value;
        this.printContent.classList.toggle("e5-hidden", !this.active || value);
    }
}